import React from 'react'
import { Routes, Route } from 'react-router-dom'
import SportsManagerLanding from './pages/SportsManagerLanding'
import Login from './pages/Login'
import Register from './pages/Register'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<SportsManagerLanding />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
    </Routes>
  )
}
